import * as CookieConsent from "vanilla-cookieconsent";

CookieConsent.run({
    // Bump deze bij een wijziging in de categorieën, anders houden bezoekers met een
    // bestaande cookie hun oude keuze en krijgen ze de nieuwe categorie nooit te zien.
    revision: 1,

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            enabled: true,
            readOnly: false
        },
        // Gekoppeld aan adPersonalization in config/google-ads.php.
        // Niet voorgevinkt: voor advertentiepersonalisatie is een actieve keuze nodig.
        advertising: {
            enabled: false,
            readOnly: false
        }
    },

    language: {
        default: 'nl',
        translations: {
            nl: {
                consentModal: {
                    title: 'Wij gebruiken cookies',
                    description: 'Om de gebruikerservaring te verbeteren maakt deze website gebruik van cookies.',
                    acceptAllBtn: 'Alles accepteren',
                    acceptNecessaryBtn: 'Alles weigeren',
                    showPreferencesBtn: 'Individuele voorkeuren beheren'
                },
                preferencesModal: {
                    title: 'Cookievoorkeuren beheren',
                    acceptAllBtn: 'Alles accepteren',
                    acceptNecessaryBtn: 'Alles weigeren',
                    savePreferencesBtn: 'Huidige selectie opslaan',
                    closeIconLabel: 'Sluit venster',
                    sections: [
                        {
                            title: 'Strikt noodzakelijke cookies',
                            description: 'Deze cookies zijn essentieel voor het correct functioneren van de website en kunnen niet worden uitgeschakeld.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Prestaties en analyse',
                            description: 'Deze cookies verzamelen informatie over hoe je onze website gebruikt. Alle gegevens zijn geanonimiseerd en kunnen niet worden gebruikt om je te identificeren.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'Advertenties',
                            description: 'Met deze cookies mag Google jouw bezoek gebruiken voor advertenties die op jou zijn afgestemd, bijvoorbeeld wanneer je onze site eerder hebt bekeken. Het meten van onze eigen advertenties valt onder Prestaties en analyse.',
                            linkedCategory: 'advertising'
                        },
                        {
                            title: 'Meer informatie',
                            description: 'Voor vragen over mijn cookiebeleid en jouw keuzes, <a href="/contact">neem contact met ons op</a>'
                        }
                    ]
                }
            }
        }
    }
});